import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Publication } from '../../interfaces/publication';
import { PublicationService } from '../../services/publication.service';
import { Subscription, combineLatest } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'angular-2-local-storage';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

@Component({
	selector: 'dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit, OnDestroy {
	@ViewChild('formRef') form: NgForm;

	subscriptions: Subscription;
	hasMediaContext: boolean;
	hasAdsContext: boolean;
	hasAnalyticsContext: boolean;
	publicationLabel: string;
	latestNewsUrl= 'https://www.bluebillywig.com/wp-json/wp/v2/updates/?per_page=100';
	latestReleaseUrl = 'https://support.bluebillywig.com/wp-json/bb/releases/ovp'; // ?includeHTML=true
	releaseItems: any[] = [];
	newsItems: any[] = [];
	isNewRelease = false;
	latestRelease: Date;
	lastVisit: number;
	maxReleases = 5;

	constructor(
		private publicationService: PublicationService,
		private authenticationService: AuthenticationService,
		private localStorageService: LocalStorageService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected location: Location,
		protected http: HttpClient) {

		this.subscriptions = new Subscription();
		this.subscriptions.add(
			this.publicationService.getData().subscribe((publication: Publication) => {
				if (publication) {
					this.publicationLabel = (publication.label ? publication.label : publication.name) + ' - Blue Billywig OVP';
				}
			})
		);

		this.lastVisit = this.localStorageService.get('ovp-lastVisit');
		this.isNewRelease = (this.lastVisit < new Date().getTime());
	}

	ngOnInit() {
		this.subscriptions.add(combineLatest([
			this.authenticationService.hasPermission('media library'),
			this.authenticationService.hasPermission('ad services'),
			this.authenticationService.hasPermission('analytics'),
			this.publicationService.getData()
		]).subscribe(([hasMediaContext, hasAdsContext, hasAnalyticsContext, publicationConfig]) => {
			this.hasMediaContext = hasMediaContext;
			this.hasAdsContext = hasAdsContext;
			this.hasAnalyticsContext = hasAnalyticsContext;

			if (publicationConfig && publicationConfig.ovpCustomHomeUrl) {
				this.router.navigate([publicationConfig.ovpCustomHomeUrl]);
			} else if (this.hasAnalyticsContext && !this.hasMediaContext && !this.hasAdsContext) {
				this.router.navigate(['/analytics/statistics']);
			}
		}));

		this.http.get(this.latestNewsUrl).subscribe((data) => {
			for (const key in data) {
				if (data.hasOwnProperty(key)) {
					this.newsItems.push(data[key]);
				}
			}
		});

		this.http.get(this.latestReleaseUrl).subscribe((releases: any) => {
			const releaseItems = releases.map(release => {
				// parse string (dd/mm/yyyy) to date object
				// todo: fix support site RSS feed to have a standardised date
				release.date = dayjs(release.date, 'DD/MM/YYYY').toDate();
				return release;
			});
			this.releaseItems = releaseItems;
			this.latestRelease = new Date(Math.max(...this.releaseItems.map(e => (e.date))));
		});
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}
}
